import classNames from "classnames";
import { ChevronRightSmallIcon } from "@icons";
import type { SideNavPickerTriggerProps } from "./SideNav.types";
import styles from "./SideNavPickerTrigger.module.scss";

/**
 * The header's workspace or organization switcher button. Pass it as a
 * `Menu` trigger; it spreads the menu's props and ref onto the `<button>` and
 * keeps its hover look while the menu is open.
 */
export const SideNavPickerTrigger = ({
    avatar,
    label,
    className,
    ref,
    ...props
}: SideNavPickerTriggerProps) => (
    <button
        ref={ref}
        type="button"
        className={classNames(styles.picker, className)}
        {...props}
    >
        <span className={styles.avatar}>{avatar}</span>
        <span className={styles.label} data-side-nav-label>
            {label}
        </span>
        <span className={styles.chevron} aria-hidden>
            <ChevronRightSmallIcon />
        </span>
    </button>
);
